import { Suspense, lazy } from "react";
import { Routes, Route } from "react-router-dom";
import { MainLayout } from "../shared/components/layout/main-layout";

const CanvasTree = lazy(() => import("../features/canvas-tree/components/canvas-tree.component"));
const CanvasTreeWithId = lazy(() => import("../features/canvas-tree/components/canvas-tree-with-id.component"));
const MapsListPage = lazy(() => import("../features/maps-list/components/maps-list-page"));
const AboutPage = lazy(() => import("../features/about/components/about-page"));

export function AppRouter() {
  return (
    <MainLayout>
      <Suspense fallback={<div className="flex items-center justify-center h-screen">Loading...</div>}>
        <Routes>
          <Route
            path="/"
            element={<CanvasTree />}
          />
          <Route
            path="/map/:id"
            element={<CanvasTreeWithId />}
          />
          <Route
            path="/maps"
            element={<MapsListPage />}
          />
          <Route
            path="/about"
            element={<AboutPage />}
          />
        </Routes>
      </Suspense>
    </MainLayout>
  );
}
